export default __webpack_public_path__ + "static/media/laptop.c7673f24.png";